import { TEvent, TPass } from "src/shared/types/globalStotre.types";
import { TTeamConfig } from "src/shared/types/teamConfig.types";

export function getUpcomingEventsToDisplay(
  passes: TPass[],
  teamConfig: TTeamConfig
) {
  const IS_PASS_GROUP_ENABLED =
    teamConfig?.TEAM_GLOBAL_SETTINGS?.IS_PASS_GROUP_ENABLED;

  let events: TEvent[] = [];

  if (
    IS_PASS_GROUP_ENABLED ||
    teamConfig?.LANDING_PAGE_SETTINGS?.DISPLAY_ALL_PASSES_EVENTS
  ) {
    passes.forEach((pass) => {
      pass?.events?.forEach((event) => {
        events.push(event);
      });
    });
  } else {
    events = passes[0]?.events || [];
  }

  return events;
}
